import { useEffect, type PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18nInstance } from '@/i18n/instance';
import { LanguageSyncService } from '@/services/languageSync';

export function LangProvider({ children }: PropsWithChildren) {
  // Listen for language changes FROM other contexts (MFE)
  useEffect(() => {
    const unsubscribe = LanguageSyncService.onLanguageChange(language => {
      // Only change if different to avoid loops
      if (i18nInstance.language !== language) {
        i18nInstance.changeLanguage(language);
      }
    });

    return unsubscribe;
  }, []);

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
